export enum Languages {
  en = 0,
  ar = 1,
}

export enum LanguagesV2 {
  AR = 1,
  EN = 2,
}

export enum Dir {
  RTL = 'rtl',
  LTR = 'ltr',
}
export const localizationSystemValues = {
  ar: {
    key: Languages.ar,
    dir: Dir.RTL,
    name: 'ar',
  },
  en: {
    key: Languages.en,
    dir: Dir.LTR,
    name: 'en',
  },
};
